import React from "react";
import PropTypes from "prop-types";
import StreetInputComponent, {PROP_NAME_STREET} from "./StreetInputComponent";
import CountryInputComponent, {PROP_NAME_COUNTRY, COUNTRY_CODE_US, COUNTRY_CODE_CANADA} from "./CountryInputComponent";
import PostalCodeInputComponent, {
    PROP_NAME_IS_POSTAL_CODE_SABRIX,
    PROP_NAME_POSTAL_CODE
} from "./PostalCodeInputComponent";
import CityStateInputComponent from "./CityStateInputComponent";
import {PROP_NAME_CITY} from "./CityInputComponent";
import {PROP_NAME_STATE} from "./StateInputComponent";
import {setupOnExtractData} from "../../../util/FormUtil";
import {trimToEmpty} from "../../../util/StringUtil";

class AddressInputComponent extends React.Component {

    constructor(props){
        super(props);
        this.extractData = this.extractData.bind(this);
    }

    componentDidMount() {
        setupOnExtractData(this);
    }

    extractData(){
        const {data} = this.props;
        const result = {};
        result[PROP_NAME_STREET] = trimToEmpty(data[PROP_NAME_STREET]);
        result[PROP_NAME_COUNTRY] = trimToEmpty(data[PROP_NAME_COUNTRY]);
        result[PROP_NAME_CITY] = trimToEmpty(data[PROP_NAME_CITY]);
        result[PROP_NAME_STATE] = trimToEmpty(data[PROP_NAME_STATE]);
        result[PROP_NAME_POSTAL_CODE] = trimToEmpty(data[PROP_NAME_POSTAL_CODE]);
        return result;
    }


    render(){
        const {data, metadata, readOnly, setFormState, userDataInit, userDataService,skipIpStackServiceCall} = this.props;
        const countryCode = data[PROP_NAME_COUNTRY];
        const isPostalCodeSabrix = data[PROP_NAME_IS_POSTAL_CODE_SABRIX];
        const isStateRequired = (countryCode === COUNTRY_CODE_US || countryCode === COUNTRY_CODE_CANADA);

        return (
            <div>
                <CountryInputComponent
                    data={data}
                    metadata={metadata}
                    readOnly={readOnly}
                    required={true}
                    userDataService={userDataService}
                    setFormState={setFormState}
                    userDataInit={userDataInit}
                    skipIpStackServiceCall={skipIpStackServiceCall}
                />
                <StreetInputComponent
                    data={data}
                    index={1}
                    metadata={metadata}
                    readOnly={readOnly}
                    required={true}
                    setFormState={setFormState}
                    userDataInit={userDataInit}
                    autoFocus={true}
                />
                <StreetInputComponent
                    data={data}
                    index={2}
                    metadata={metadata}
                    readOnly={readOnly}
                    required={false}
                    setFormState={setFormState}
                    userDataInit={userDataInit}
                    autoFocus={false}
                />
                <PostalCodeInputComponent
                    data={data}
                    disabled={!countryCode}
                    metadata={metadata}
                    // Countries like Egypt, Hong Kong (or islands) do not have a Postal Code
                    required={isPostalCodeSabrix}
                    readOnly={readOnly}
                    userDataService={userDataService}
                    setFormState={setFormState}
                    userDataInit={userDataInit}
                />
                <CityStateInputComponent
                    cityRequired={true}
                    data={data}
                    isPostalCodeSabrix={isPostalCodeSabrix}
                    metadata={metadata}
                    readOnly={readOnly}
                    userDataService={userDataService}
                    setFormState={setFormState}
                    stateRequired={isStateRequired}
                    userDataInit={userDataInit}
                />
            </div>
        );
    }
}


AddressInputComponent.propTypes = {
    data: PropTypes.object.isRequired,
    metadata: PropTypes.object.isRequired,
    readOnly: PropTypes.object,
    setFormState: PropTypes.func.isRequired,
    userDataInit: PropTypes.object.isRequired,
    userDataService: PropTypes.object.isRequired,
    onExtractData: PropTypes.func
};

export default AddressInputComponent;